import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithErrorHandling } from "../baseQuery";

export const servicesDataApi = createApi({
  reducerPath: "servicesDataApi",
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ["ServicesData"],
  endpoints: (builder) => ({
    // ✅ Get all
    getServicesData: builder.query({
      query: () => "/servicesData",
      providesTags: ["ServicesData"],
    }),

    // ✅ Get by ID
    getServiceDataById: builder.query({
      query: (id) => `/servicesData/${id}`,
      providesTags: (result, error, id) => [{ type: "ServicesData", id }],
    }),

    // ✅ Create
    createServiceData: builder.mutation({
      query: (data) => ({
        url: "/servicesData",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["ServicesData"],
    }),

    // ✅ Update
    updateServiceData: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/servicesData/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "ServicesData", id },
      ],
    }),

    // ✅ Delete
    deleteServiceData: builder.mutation({
      query: (id) => ({
        url: `/servicesData/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ServicesData"],
    }),

    // ✅ Toggle service status
    toggleServiceStatus: builder.mutation({
      query: (id) => ({
        url: `/servicesData/${id}/toggle`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [{ type: "ServicesData", id }],
    }),
  }),
});

export const {
  useGetServicesDataQuery,
  useGetServiceDataByIdQuery,
  useCreateServiceDataMutation,
  useUpdateServiceDataMutation,
  useDeleteServiceDataMutation,
  useToggleServiceStatusMutation
} = servicesDataApi;
